import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseFilterTag } from '../components/base-filter-tag/Component.js';
import 'classnames';
import '@alfalab/hooks';
import '@alfalab/icons-glyph/ChevronDownCompactSIcon';
import '@alfalab/icons-glyph/ChevronDownMIcon';
import '@alfalab/icons-glyph/CrossCircleMIcon';
import '@alfalab/icons-glyph/CrossCircleSIcon';

var styles = {"component":"filter-tag__component_1k6sf","rectangular":"filter-tag__rectangular_1k6sf","xxs":"filter-tag__xxs_1k6sf","xs":"filter-tag__xs_1k6sf","s":"filter-tag__s_1k6sf","valueButton":"filter-tag__valueButton_1k6sf","filled":"filter-tag__filled_1k6sf","checked":"filter-tag__checked_1k6sf","close":"filter-tag__close_1k6sf","clear":"filter-tag__clear_1k6sf"};
require('./mobile.css');

var FilterTagMobile = forwardRef(function (restProps, ref) { return React.createElement(BaseFilterTag, __assign({}, restProps, { ref: ref, styles: styles })); });

export { FilterTagMobile };
